var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CD1C45",
    d: "M6.024.463a.5.5 0 0 1 .952 0l1.096 3.374a.5.5 0 0 0 .475.345h3.547a.5.5 0 0 1 .294.905l-2.87 2.085a.5.5 0 0 0-.181.559l1.096 3.373a.5.5 0 0 1-.77.56l-2.87-2.085a.5.5 0 0 0-.587 0l-2.87 2.084a.5.5 0 0 1-.769-.559l1.096-3.373a.5.5 0 0 0-.182-.56L.611 5.088a.5.5 0 0 1 .295-.905h3.547a.5.5 0 0 0 .475-.345z"
  })));
};
export default SvgStarFilled;